export const categories = [
  {
    slug: 'riju',
    name: '日剧',
    nameJa: '日本ドラマ',
    description: '精选日本电视剧，涵盖爱情、悬疑、职场等多种题材',
    icon: 'ri-tv-line',
    color: 'primary',
    imageSeq: 'cat-jdrama-01',
    imageQuery: 'Japanese%20drama%20series%20poster%20collection%20elegant%20minimalist%20design%20with%20warm%20lighting%20and%20clean%20aesthetic%2C%20cinematic%20atmosphere%2C%20professional%20photography%20style%2C%20soft%20gradient%20background%20in%20warm%20cream%20tones',
  },
  {
    slug: 'handong',
    name: '韩剧',
    nameJa: '韓国ドラマ',
    description: '热门韩剧大全，浪漫爱情与精彩剧情完美融合',
    icon: 'ri-heart-line',
    color: 'accent',
    imageSeq: 'cat-kdrama-01',
    imageQuery: 'Korean%20drama%20series%20poster%20collection%20modern%20romantic%20design%20with%20soft%20warm%20lighting%2C%20cinematic%20Korean%20aesthetic%2C%20elegant%20composition%2C%20cream%20and%20beige%20background%20tones',
  },
  {
    slug: 'dongman',
    name: '动漫',
    nameJa: 'アニメ',
    description: '日本动漫精选，热血、治愈、奇幻等各类风格应有尽有',
    icon: 'ri-movie-line',
    color: 'primary',
    imageSeq: 'cat-anime-01',
    imageQuery: 'Japanese%20anime%20art%20style%20illustration%20collection%20vibrant%20colors%20with%20soft%20background%2C%20clean%20modern%20design%2C%20warm%20atmosphere%2C%20artistic%20composition%20with%20cream%20gradient%20background',
  },
  {
    slug: 'zongyi',
    name: '综艺',
    nameJa: 'バラエティ',
    description: '日韩热门综艺节目，搞笑、竞技、旅行等精彩不断',
    icon: 'ri-emotion-laugh-line',
    color: 'accent',
    imageSeq: 'cat-variety-01',
    imageQuery: 'Variety%20show%20vibrant%20colorful%20poster%20design%20with%20playful%20atmosphere%2C%20warm%20lighting%2C%20clean%20modern%20composition%2C%20soft%20cream%20background%2C%20entertainment%20style%20photography',
  },
  {
    slug: 'dianying',
    name: '电影',
    nameJa: '映画',
    description: '日韩精选电影，从经典到新片，一站式观影体验',
    icon: 'ri-film-line',
    color: 'primary',
    imageSeq: 'cat-movie-01',
    imageQuery: 'Japanese%20and%20Korean%20cinema%20movie%20poster%20collection%20cinematic%20atmosphere%2C%20warm%20golden%20lighting%2C%20elegant%20minimalist%20design%2C%20soft%20cream%20gradient%20background%2C%20professional%20film%20photography%20style',
  },
  {
    slug: 'yinyue',
    name: '音乐',
    nameJa: '音楽',
    description: '日韩流行音乐MV、演唱会现场，视听双重享受',
    icon: 'ri-music-line',
    color: 'accent',
    imageSeq: 'cat-music-01',
    imageQuery: 'Japanese%20Korean%20music%20concert%20stage%20atmosphere%20with%20warm%20spotlight%20and%20soft%20gradient%20background%2C%20elegant%20performance%20photography%20style%2C%20clean%20composition%2C%20cream%20and%20golden%20tones',
  },
];

export const articles = [
  {
    id: 'article-1',
    title: '2024年最值得期待的日剧TOP10推荐',
    excerpt: '新的一年，日剧市场迎来了众多精彩作品。我们为您精选了十部最值得期待的日剧，从悬疑推理到温情治愈，应有尽有。',
    content: `
      <p>2024年日剧市场可谓是百花齐放，众多实力派演员携手优秀制作团队，为观众带来了一部又一部精彩绝伦的作品。</p>
      <h3>1. 《重启人生》第二季</h3>
      <p>安藤樱主演的现象级作品回归，延续第一季的温馨与感动，讲述主人公在重生中找寻人生真谛的故事。剧本由笨蛋节奏亲自操刀，每一集都充满了令人回味的细节。</p>
      <h3>2. 《沉默的巡游》</h3>
      <p>福山雅治再次饰演天才物理学家汤川学，这次他将面对一起看似完美的不在场证明案件。东野圭吾原著改编，悬疑氛围浓厚。</p>
      <h3>3. 《First Love 初恋》特别篇</h3>
      <p>延续Netflix同名热剧的世界观，满岛光和佐藤健再度合作，讲述平行时空中的另一个爱情故事，画面唯美，配乐动人。</p>
      <p>除此之外，还有《弥留之国的爱丽丝》第三季、《深夜食堂》新系列等多部备受瞩目的作品即将与观众见面。</p>
      <p>aaa日韩将持续为您追踪最新日剧动态，第一时间更新精彩内容。</p>
    `,
    category: '日剧',
    categorySlug: 'riju',
    image: 'https://readdy.ai/api/search-image?query=Japanese%20drama%20series%20cinematic%20scene%20with%20warm%20lighting%20and%20emotional%20atmosphere%2C%20Japanese%20city%20night%20background%2C%20soft%20bokeh%20effect%2C%20elegant%20composition%2C%20professional%20film%20photography&width=800&height=450&seq=article-1-main&orientation=landscape',
    date: '2024-12-15',
    author: 'aaa日韩编辑部',
    tags: ['日剧推荐', '2024日剧', '日剧排行'],
    views: 12850,
  },
  {
    id: 'article-2',
    title: '韩剧《眼泪女王》深度解析：爱情的另一种模样',
    excerpt: '金秀贤与金智媛主演的《眼泪女王》引爆话题，本文将为您深度解析剧中令人动容的爱情故事与精湛演技。',
    content: `
      <p>《眼泪女王》作为2024年最受瞩目的韩剧之一，自开播以来便引发了广泛的讨论与关注。金秀贤与金智媛的精彩演绎，让这部作品成为了当年讨论度最高的电视剧。</p>
      <h3>剧情概述</h3>
      <p>故事围绕财阀家族的继承人洪海仁（金智媛饰）与平凡律师白贤宇（金秀贤饰）之间的婚姻展开。三年婚姻濒临破裂之际，海仁被诊断出绝症，而贤宇在得知真相后的反应，让两人的关系发生了微妙的变化。</p>
      <h3>角色分析</h3>
      <p>金秀贤饰演的白贤宇表面冷漠实则深情，他对角色的诠释细腻入微，每一个眼神都充满了故事。金智媛则将洪海仁的坚强与脆弱完美融合，塑造了一个令人心疼又敬佩的女性形象。</p>
      <h3>为什么这部剧值得看</h3>
      <p>不仅仅是一部爱情剧，《眼泪女王》深入探讨了婚姻、家庭与自我价值的主题。编剧巧妙地运用了反转与伏笔，让观众在感动之余也能感受到故事的深度。</p>
      <p>aaa日韩为您提供《眼泪女王》高清完整版，支持多端同步观看。</p>
    `,
    category: '韩剧',
    categorySlug: 'handong',
    image: 'https://readdy.ai/api/search-image?query=Korean%20drama%20romantic%20scene%20with%20golden%20hour%20lighting%20and%20emotional%20atmosphere%2C%20elegant%20couple%20silhouette%2C%20soft%20bokeh%20background%2C%20cinematic%20composition%2C%20warm%20cream%20tones&width=800&height=450&seq=article-2-main&orientation=landscape',
    date: '2024-12-10',
    author: 'aaa日韩编辑部',
    tags: ['韩剧推荐', '眼泪女王', '金秀贤', '金智媛'],
    views: 25630,
  },
  {
    id: 'article-3',
    title: '《葬送的芙莉莲》为何成为年度最佳动画',
    excerpt: '这部讲述精灵魔法使旅途的作品，以其独特的叙事方式和深刻的情感表达，征服了全球观众的心。',
    content: `
      <p>《葬送的芙莉莲》改编自山田钟人原作、阿部司作画的同名漫画，由MADHOUSE制作，自播出以来便获得了极高的评价。</p>
      <h3>独特的叙事结构</h3>
      <p>故事从勇者小队击败魔王之后开始，以精灵魔法使芙莉莲的视角，讲述她重新踏上旅途、理解人类情感的过程。这种\"后日谈\"式的叙事结构在动漫作品中极为罕见，赋予了故事独特的魅力。</p>
      <h3>情感表达的深度</h3>
      <p>《葬送的芙莉莲》最打动人心的地方在于它对\"时间\"与\"情感\"的诠释。作为长寿精灵的芙莉莲，在她漫长生命中的十年不过弹指一挥间，但对于人类伙伴而言却是一生。这种时间感知的差异所带来的遗憾与领悟，让每一位观众都能感同身受。</p>
      <h3>精良的制作水准</h3>
      <p>MADHOUSE的制作质量毋庸置疑，精美的画面、恰到好处的配乐、细腻的情感表达，每一个环节都展现了顶级动画制作的水准。</p>
      <p>aaa日韩为您提供《葬送的芙莉莲》高清完整版，尽享极致观影体验。</p>
    `,
    category: '动漫',
    categorySlug: 'dongman',
    image: 'https://readdy.ai/api/search-image?query=Japanese%20anime%20fantasy%20scenery%20with%20magical%20atmosphere%20and%20warm%20sunlight%20through%20trees%2C%20elegant%20elf%20character%20journey%20theme%2C%20soft%20golden%20lighting%2C%20beautiful%20nature%20background%2C%20cinematic%20composition&width=800&height=450&seq=article-3-main&orientation=landscape',
    date: '2024-12-05',
    author: 'aaa日韩编辑部',
    tags: ['动漫推荐', '葬送的芙莉莲', '年度最佳'],
    views: 18920,
  },
  {
    id: 'article-4',
    title: '韩国综艺《Running Man》经典特辑回顾',
    excerpt: '陪伴观众十余年的《Running Man》创造了无数经典时刻，让我们一起回顾那些令人难忘的特辑。',
    content: `
      <p>自2010年开播以来，《Running Man》已经陪伴全球观众走过了十多个年头。作为韩国最长寿的综艺节目之一，它创造了无数令人捧腹大笑又感动落泪的瞬间。</p>
      <h3>超能力特辑</h3>
      <p>这是《Running Man》最经典的系列之一，成员们各自获得独特的超能力，在游戏中展开激烈的对决。时间暂停、空间移动、读心术等充满想象力的设定，让观众们大呼过瘾。</p>
      <h3>全球特辑</h3>
      <p>从香港到迪拜，从澳大利亚到英国，《Running Man》的脚步遍布全球。这些海外特辑不仅展示了成员们在不同文化环境中的有趣互动，也为观众呈现了世界各地的风土人情。</p>
      <h3>年末颁奖典礼</h3>
      <p>每年年末的颁奖典礼特辑是RM粉最期待的节目之一，搞笑的奖项设置、成员们的即兴表演，以及温情满满的年度回顾，都让人感受到这个大家庭的温暖。</p>
      <p>aaa日韩为您提供《Running Man》全季高清资源，随时随地重温经典。</p>
    `,
    category: '综艺',
    categorySlug: 'zongyi',
    image: 'https://readdy.ai/api/search-image?query=Korean%20variety%20show%20playful%20atmosphere%20with%20colorful%20set%20design%20and%20warm%20studio%20lighting%2C%20entertainment%20program%20photography%20style%2C%20fun%20vibrant%20composition%2C%20soft%20cream%20background&width=800&height=450&seq=article-4-main&orientation=landscape',
    date: '2024-11-28',
    author: 'aaa日韩编辑部',
    tags: ['韩国综艺', 'Running Man', '综艺回顾'],
    views: 15340,
  },
  {
    id: 'article-5',
    title: '日本电影《怪物》获戛纳最佳编剧奖深度解读',
    excerpt: '是枝裕和导演携手坂元裕二编剧的《怪物》，以多视角叙事探讨了人性与偏见，荣获第76届戛纳电影节最佳编剧奖。',
    content: `
      <p>《怪物》由日本著名导演是枝裕和执导，坂元裕二编剧，安藤樱、永山瑛太主演，在第76届戛纳电影节上荣获最佳编剧奖，并获得了长达9分30秒的起立鼓掌。</p>
      <h3>多视角叙事的精妙设计</h3>
      <p>电影通过母亲、老师、孩子三个视角，层层剥开同一事件的真相。坂元裕二的剧本结构精巧，每一次视角转换都带来新的信息与情感冲击，让观众在不断修正认知的过程中，深刻反思\"什么是真相\"。</p>
      <h3>是枝裕和的导演美学</h3>
      <p>是枝裕和一贯的克制与温情在本片中发挥得淋漓尽致。他不急于给出判断，而是让观众随着故事的展开，自己去感受、去理解每一个角色的处境与选择。</p>
      <h3>社会议题的深度探讨</h3>
      <p>《怪物》不仅仅是一部悬疑片，它触及了校园欺凌、教育体制、社会偏见等多重社会议题，引发观众对当代社会问题的深入思考。</p>
      <p>aaa日韩为您提供《怪物》高清完整版，感受这部戛纳获奖作品的独特魅力。</p>
    `,
    category: '电影',
    categorySlug: 'dianying',
    image: 'https://readdy.ai/api/search-image?query=Japanese%20cinema%20artistic%20scene%20with%20contemplative%20mood%20and%20soft%20natural%20lighting%2C%20Japanese%20school%20setting%20atmosphere%2C%20elegant%20minimalist%20composition%2C%20warm%20cream%20tones%2C%20film%20photography%20style&width=800&height=450&seq=article-5-main&orientation=landscape',
    date: '2024-11-20',
    author: 'aaa日韩编辑部',
    tags: ['日本电影', '是枝裕和', '怪物', '戛纳'],
    views: 9870,
  },
  {
    id: 'article-6',
    title: 'YOASOBI东京巨蛋演唱会：音乐与视觉的极致盛宴',
    excerpt: '日本超人气组合YOASOBI在东京巨蛋举办的演唱会座无虚席，将小说化为音乐的概念再次惊艳全场。',
    content: `
      <p>YOASOBI作为日本最具代表性的音乐组合之一，以其独特的\"将小说化为音乐\"的概念，在全球范围内积累了庞大的粉丝群体。此次东京巨蛋演唱会更是一票难求。</p>
      <h3>演出亮点</h3>
      <p>演唱会以《夜に駆ける》开场，瞬间点燃全场气氛。Ayase的电子音乐与ikura清澈的嗓音完美融合，配合精心设计的舞台灯光与视觉效果，为观众带来了一场视听盛宴。</p>
      <h3>概念化的舞台设计</h3>
      <p>每一首歌的舞台背景都与其对应的小说故事相呼应，从《怪物》的暗黑风格到《アイドル》的华丽舞台，每一个细节都体现了团队对音乐与视觉表达的极致追求。</p>
      <h3>粉丝互动</h3>
      <p>YOASOBI特别设置了粉丝点歌环节，还首次公开演唱了为此次演唱会特别创作的新曲，让现场粉丝惊喜不已。</p>
      <p>aaa日韩为您提供YOASOBI演唱会高清完整版，随时随地重温这场音乐盛宴。</p>
    `,
    category: '音乐',
    categorySlug: 'yinyue',
    image: 'https://readdy.ai/api/search-image?query=Japanese%20music%20concert%20stage%20with%20colorful%20lighting%20and%20large%20crowd%20atmosphere%2C%20Tokyo%20Dome%20performance%20photography%2C%20vibrant%20energy%2C%20warm%20stage%20lights%2C%20professional%20concert%20photography%20style&width=800&height=450&seq=article-6-main&orientation=landscape',
    date: '2024-11-15',
    author: 'aaa日韩编辑部',
    tags: ['日本音乐', 'YOASOBI', '演唱会', '东京巨蛋'],
    views: 21450,
  },
];

export const faqs = [
  {
    question: 'aaa日韩平台是否需要注册才能观看？',
    answer: 'aaa日韩平台支持免费注册，注册后即可享受海量日韩正版内容。部分内容支持游客模式预览，但完整观看需要注册账号，以便为您提供个性化的内容推荐和观看历史记录。',
  },
  {
    question: 'aaa日韩支持哪些设备观看？',
    answer: 'aaa日韩支持全平台观看，包括网页端（Windows/Mac）、手机端（iOS/Android）、平板端以及智能电视。您可以在不同设备间无缝切换，观看记录和收藏内容会自动同步，让您随时随地享受aaa日韩的精彩内容。',
  },
  {
    question: 'aaa日韩的内容更新频率如何？',
    answer: 'aaa日韩坚持每日更新，确保您能第一时间观看到最新的日韩影视、综艺、动漫和音乐内容。同时，我们也会定期补充经典资源库，让您不错过任何优质内容。',
  },
  {
    question: 'aaa日韩的视频画质如何？',
    answer: 'aaa日韩提供最高4K超高清画质，支持根据网络状况自动调整清晰度。我们还配备了先进的视频压缩技术，在保证高清画质的同时，降低流量消耗，让您在任何网络环境下都能享受流畅的观看体验。',
  },
  {
    question: '如何联系aaa日韩客服？',
    answer: '您可以通过以下方式联系我们的客服团队：发送邮件至 support@aaarihan.com，或访问我们的"关于我们"页面使用在线联系表单。我们的客服团队会在24小时内回复您的咨询。',
  },
  {
    question: 'aaa日韩的内容是否都有中文字幕？',
    answer: '是的，aaa日韩平台上的所有日韩内容都配备了专业的中文字幕。我们的字幕团队由资深翻译组成，确保字幕的准确性和时效性，让您无障碍享受日韩优质内容。',
  },
];

export const stats = [
  { value: '5000+', label: '正版资源' },
  { value: '1000万+', label: '注册用户' },
  { value: '99.9%', label: '服务可用率' },
  { value: '4K', label: '超高清画质' },
];

export const features = [
  {
    icon: 'ri-shield-check-line',
    title: '正版授权',
    description: '全部内容均获得正版授权，为您提供合法、安全的观影体验，支持创作者权益。',
  },
  {
    icon: 'ri-4k-line',
    title: '超高清画质',
    description: '支持最高4K分辨率播放，HDR显示技术让画面更加生动逼真，沉浸式观影体验。',
  },
  {
    icon: 'ri-device-line',
    title: '多终端同步',
    description: '支持手机、平板、电脑、电视等多终端无缝切换，观影记录实时同步。',
  },
  {
    icon: 'ri-translate-2',
    title: '专业字幕',
    description: '资深翻译团队精心制作中文字幕，准确传达原作精髓，无障碍欣赏日韩内容。',
  },
  {
    icon: 'ri-refresh-line',
    title: '每日更新',
    description: '内容团队每日持续更新，最新日韩影视综艺动漫第一时间上线，永不错过精彩。',
  },
  {
    icon: 'ri-customer-service-2-line',
    title: '贴心客服',
    description: '7×24小时在线客服支持，快速响应您的问题与建议，用心服务每一位用户。',
  },
];